/** @format */

import {ReactElement, ReactNode, useCallback, useMemo, useState} from 'react';

import Alert from '@mui/material/Alert';
import {Trans} from 'react-i18next';

export const ID_APOLLO_ERROR = 'apollo-error';

interface ApolloErrorReturn {
  onError: (message?: string) => void;
  onRemoveError: () => void;
  isError: boolean;
  renderAlert: ReactElement | null;
}

/**
 * Хук выводит общую ошибку в верстку, если произошла ошибка Apollo.
 */

const useApolloError = (): ApolloErrorReturn => {
  const [apolloError, setApolloError] = useState<null | string | ReactNode>(null);

  const onError = useCallback((message?: string) => {
    setApolloError(message || <Trans>Что-то пошло не так</Trans>);
  }, []);

  const onRemoveError = useCallback(() => {
    setApolloError(null);
  }, []);

  const renderAlert = useMemo(() => {
    return apolloError ? (
      <Alert severity='error' data-testid={ID_APOLLO_ERROR}>
        {apolloError}
      </Alert>
    ) : null;
  }, [apolloError]);

  return {
    onError,
    renderAlert,
    onRemoveError,
    isError: Boolean(apolloError),
  };
};

export {useApolloError};
